$paragraph--color: var(--paragraph-color, $text-color);
$paragraph--line-height: var(--paragraph-line-height, 1.5);

:host {
  @include reset-host;
  @include reset-text;
}

:host .paragraph {
  color: $paragraph--color;
  font-weight: $fw-regular;
  font-size: $fs-base;
  line-height: $paragraph--line-height;
  letter-spacing: 0.14px;

  &.is-xs {
    font-size: $fs-xs;
  }

  &.is-sm {
    font-size: $fs-sm;
  }

  &.is-base {
    font-size: $fs-base;
  }

  &.is-md {
    font-size: $fs-lg;
  }

  &.is-lg {
    font-size: $fs-xl;
  }

  &.is-xl {
    font-size: $fs-2xl;
    line-height: 1.4;

    @include mq('max', 'md') {
      font-size: $fs-xl;
    }
  }

  &.has-xs-margin {
    margin-bottom: map-get($spacing-sizes, 1);
  }

  &.has-sm-margin {
    margin-bottom: map-get($spacing-sizes, 2);
  }

  &.has-md-margin {
    margin-bottom: map-get($spacing-sizes, 3);
  }

  &.has-lg-margin {
    margin-bottom: map-get($spacing-sizes, 4);
  }

  &.has-xl-margin {
    margin-bottom: map-get($spacing-sizes, 5);
  }

  strong {
    font-weight: $fw-medium;
  }

  em {
    color: $color-purple;
    font-weight: $fw-medium;
    font-style: normal;
  }

  button {
    padding: 0;

    color: $color-purple;
    font-size: inherit;
    font-family: inherit;
    text-decoration: underline;

    background: transparent;
    border: 0;
    cursor: pointer;
  }
}
